import * as React from 'react';
const SvgGuest = (props) => (
  <svg viewBox="0 0 110 120" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#guest_svg__a)">
      <path
        d="M34.051 114.894c0-3.036.447-6.478-1.263-9.164-1.988-3.134-5.671-3.253-8.957-3.966-4.095-.889-7.953-1.168-12.104-.28-2.797.602-6.871.769-9.04 2.77-3 2.77-2.484 6.946-2.484 10.64 0 1.923 2.979 1.923 2.979 0 0-3.47-.782-8.541 3.697-9.346 3.397-.615 6.774-1.749 10.248-1.749 3.474 0 6.858 1.141 10.248 1.749 4.472.805 3.697 5.876 3.697 9.346 0 1.923 2.98 1.923 2.98 0Z"
        fill="#000"
        stroke="#000"
        strokeWidth={0.5}
        strokeMiterlimit={10}
      />
      <path
        d="M6.983 88.019c.182 5.533 4.5 10.17 10.144 10.17 5.643 0 10.143-4.637 10.143-10.17s-4.618-10.171-10.143-10.171-9.97 4.645-10.144 10.17c-.062 1.924 2.916 1.917 2.98 0 .125-3.916 3.16-7.19 7.17-7.19 4.012 0 7.172 3.273 7.172 7.19 0 3.918-3.09 7.03-6.885 7.178-4.116.16-7.325-3.155-7.45-7.177-.064-1.917-3.042-1.924-2.98 0h-.007Z"
        fill="#000"
      />
      <path
        d="M6.983 88.019c.182 5.533 4.5 10.17 10.144 10.17 5.643 0 10.143-4.637 10.143-10.17s-4.618-10.171-10.143-10.171-9.97 4.645-10.144 10.17Zm0 0c-.062 1.923 2.916 1.916 2.98 0 .125-3.918 3.16-7.191 7.17-7.191 4.012 0 7.172 3.273 7.172 7.19 0 3.918-3.09 7.03-6.885 7.178-4.116.16-7.325-3.155-7.45-7.177-.064-1.917-3.042-1.924-2.98 0h-.007Z"
        stroke="#000"
        strokeWidth={0.5}
        strokeMiterlimit={10}
      />
      <path
        d="M71.917 118.384c0-3.036.447-6.477-1.262-9.163-1.988-3.134-5.672-3.253-8.965-3.966-4.095-.889-7.952-1.169-12.103-.28-2.798.601-6.872.769-9.041 2.77-3 2.77-2.484 6.946-2.484 10.639 0 1.917 2.979 1.924 2.979 0 0-3.469-.781-8.541 3.697-9.345 3.398-.616 6.774-1.749 10.248-1.749 3.474 0 6.858 1.14 10.248 1.749 4.472.804 3.698 5.876 3.698 9.345 0 1.917 2.978 1.924 2.978 0h.007Z"
        fill="#000"
        stroke="#000"
        strokeWidth={0.5}
        strokeMiterlimit={10}
      />
      <path
        d="M44.85 91.502c.181 5.533 4.5 10.171 10.143 10.171 5.644 0 10.143-4.638 10.143-10.17 0-5.534-4.618-10.171-10.143-10.171s-9.969 4.644-10.143 10.17c-.063 1.924 2.916 1.917 2.978 0 .126-3.917 3.16-7.19 7.172-7.19 4.011 0 7.171 3.273 7.171 7.19 0 3.918-3.09 7.03-6.885 7.177-4.116.161-7.325-3.154-7.45-7.177-.063-1.916-3.042-1.923-2.98 0h-.006Z"
        fill="#000"
      />
      <path
        d="M44.85 91.502c.181 5.533 4.5 10.171 10.143 10.171 5.644 0 10.143-4.638 10.143-10.17 0-5.534-4.618-10.171-10.143-10.171s-9.969 4.644-10.143 10.17Zm0 0c-.063 1.924 2.916 1.917 2.978 0 .126-3.917 3.16-7.19 7.172-7.19 4.011 0 7.171 3.273 7.171 7.19 0 3.918-3.09 7.03-6.885 7.177-4.116.161-7.325-3.154-7.45-7.177-.063-1.916-3.042-1.923-2.98 0h-.006Z"
        stroke="#000"
        strokeWidth={0.5}
        strokeMiterlimit={10}
      />
      <path
        d="M109.777 114.894c0-3.036.446-6.478-1.263-9.164-1.988-3.134-5.671-3.253-8.964-3.966-4.095-.889-7.953-1.168-12.104-.28-2.797.602-6.871.769-9.04 2.77-3 2.77-2.485 6.946-2.485 10.64 0 1.923 2.98 1.923 2.98 0 0-3.47-.782-8.541 3.697-9.346 3.397-.615 6.774-1.749 10.248-1.749 3.474 0 6.857 1.141 10.248 1.749 4.471.805 3.697 5.876 3.697 9.346 0 1.923 2.979 1.923 2.979 0h.007Z"
        fill="#000"
        stroke="#000"
        strokeWidth={0.5}
        strokeMiterlimit={10}
      />
      <path
        d="M82.709 88.019c.181 5.533 4.5 10.17 10.143 10.17 5.644 0 10.144-4.637 10.144-10.17s-4.619-10.171-10.144-10.171-9.969 4.645-10.143 10.17c-.063 1.924 2.916 1.917 2.979 0 .125-3.916 3.16-7.19 7.171-7.19 4.012 0 7.172 3.273 7.172 7.19 0 3.918-3.09 7.03-6.886 7.178-4.116.16-7.325-3.155-7.45-7.177-.063-1.917-3.035-1.924-2.979 0h-.007Z"
        fill="#000"
      />
      <path
        d="M82.709 88.019c.181 5.533 4.5 10.17 10.143 10.17 5.644 0 10.144-4.637 10.144-10.17s-4.619-10.171-10.144-10.171-9.969 4.645-10.143 10.17Zm0 0c-.063 1.923 2.916 1.916 2.979 0 .125-3.918 3.16-7.191 7.171-7.191 4.012 0 7.172 3.273 7.172 7.19 0 3.918-3.09 7.03-6.886 7.178-4.116.16-7.325-3.155-7.45-7.177-.063-1.917-3.035-1.924-2.979 0h-.007Z"
        stroke="#000"
        strokeWidth={0.5}
        strokeMiterlimit={10}
      />
      <path
        d="M86.03 52.344H23.949l1.486 1.49v-8.877l-1.486 1.49h62.08l-1.485-1.49v8.877c0 1.924 2.978 1.924 2.978 0v-8.877c0-.804-.683-1.49-1.485-1.49H23.949c-.802 0-1.486.686-1.486 1.49v8.877c0 .804.684 1.49 1.486 1.49h62.08c1.912 0 1.919-2.987 0-2.987v.007Z"
        fill="#000"
        stroke="#000"
        strokeWidth={0.5}
        strokeMiterlimit={10}
      />
      <path
        d="M30.158 53.841v25.252c0 1.917 2.979 1.924 2.979 0V53.841c0-1.917-2.979-1.924-2.979 0ZM76.85 53.841v25.252c0 1.917 2.978 1.924 2.978 0V53.841c0-1.917-2.978-1.924-2.978 0ZM65.834 44.964c.188-2.763.376-5.526.558-8.289.132-1.916-2.846-1.91-2.979 0a3294.14 3294.14 0 0 0-.558 8.29c-.133 1.916 2.846 1.909 2.979 0ZM43.587 36.675c.188 2.763.377 5.526.558 8.289.125 1.903 3.104 1.917 2.979 0-.189-2.763-.377-5.526-.558-8.29-.126-1.902-3.105-1.916-2.98 0Z"
        fill="#000"
        stroke="#000"
        strokeWidth={0.5}
        strokeMiterlimit={10}
      />
      <path
        d="M75.873 44.964c0-3.77.111-7.561 0-11.325-.091-3.085-1.57-5.855-4.354-7.303-1.96-1.014-4.632-1.09-6.801-1.49-2.581-.475-5.17-1.035-7.8-1.203-3.292-.21-6.487.252-9.71.847-2.135.391-4.277.77-6.411 1.077-3.412.49-6.14 3.407-6.6 6.792-.558 4.092-.098 8.485-.098 12.612 0 1.917 2.98 1.924 2.98 0V34.444c0-2.428.767-4.757 3.264-5.694 1.723-.65 4.095-.72 5.916-1.057 2.386-.44 4.765-.958 7.192-1.084 2.895-.147 5.7.245 8.532.763 1.814.335 3.642.755 5.47 1.007 3.076.42 5.322 1.875 5.448 5.267.146 3.764 0 7.562 0 11.325 0 1.917 2.979 1.924 2.979 0l-.007-.007Z"
        fill="#000"
        stroke="#000"
        strokeWidth={0.5}
        strokeMiterlimit={10}
      />
      <path
        d="M62.715 10.884c-.125 4.218-3.418 7.744-7.722 7.744-4.305 0-7.71-3.526-7.723-7.744-.014-4.113 3.348-7.59 7.444-7.736 4.415-.154 7.876 3.406 8.001 7.736.056 1.917 3.035 1.924 2.979 0-.133-4.42-2.686-8.373-6.844-9.996-4.255-1.664-9.222-.342-12.117 3.197-6.146 7.527.495 18.95 10.039 17.369 5.19-.86 8.762-5.393 8.915-10.563.056-1.923-2.916-1.916-2.979 0l.007-.007Z"
        fill="#000"
      />
      <path
        d="M62.715 10.884c-.125 4.218-3.418 7.744-7.722 7.744-4.305 0-7.71-3.526-7.723-7.744-.014-4.113 3.348-7.59 7.444-7.736 4.415-.154 7.876 3.406 8.001 7.736Zm0 0c.056 1.917 3.035 1.924 2.979 0-.133-4.42-2.686-8.373-6.844-9.996-4.255-1.664-9.222-.342-12.117 3.197-6.146 7.527.495 18.95 10.039 17.369 5.19-.86 8.762-5.393 8.915-10.563.056-1.923-2.916-1.916-2.979 0l.007-.007Z"
        stroke="#000"
        strokeWidth={0.5}
        strokeMiterlimit={10}
      />
    </g>
    <defs>
      <clipPath id="guest_svg__a">
        <path fill="#fff" d="M0 0h110v120H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgGuest;
